import React from 'react'
import './Home.css'
import Typical from "react-typical"
import ProSF from './images/ProSF.jpg'
import ProW from './images/ProW.jpg'
import ProWa from './images/ProWa.jpg'
import ProAgric from './images/ProAgric.jpg'
import Carosel from './Carosel'
import { Fade } from 'react-reveal'
import Footer from './Footer'


function Home() {
    return (
        <div className='home'>
<Carosel />

            <div className="home__typical">
                <h1>
                <Typical
                loop={Infinity}
                steps={[
                    "Welcome To",
                    2000,
                    "Madamfo Ghana",
                    2000,
                    "Foundation ev",
                    2000,
                    "Bettina Landgrafe",
                    2000,
                    " Helping People",
                    2000,
                    "To Help Themselves",
                    2000,
                ]}
            />
            </h1>
            </div>
            <Fade top >
                <div className='who__weAreDiv'>
                    <div className="who__weArecontainer">
                        <h4>Who We Are</h4>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Animi cumque quibusdam iusto blanditiis doloribus aperiam quas ratione nemo sint dolores officia adipisci sit eaque itaque excepturi molestiae, fugit quis velit.</p>
                    </div>
            </div>
</Fade>
            <div className="home__projects">
                <h4>Our Projects</h4>

                <div className="home__project">
                    <img
                        src={ProSF}
                        alt=''
                    />
                    <div className="home__projectInfo">
                        <h4>School Feeding Program</h4>
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing yeewv sugewwevjv voluptatem?</p>
                    </div>
                </div>
                <div className="home__project">
                    <img
                        src={ProW}
                        alt=''
                    />
                    <div className="home__projectInfo">
                        <h4>School Feeding Program</h4>
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing yeewv sugewwevjv voluptatem?</p>
                    </div>
                </div>
                <div className="home__project">
                    <img
                        src={ProWa}
                        alt=''
                    />
                    <div className="home__projectInfo">
                        <h4>School Feeding Program</h4>
                        <p>Lorem ipsum dolor
                            aa efbebfuer erhiher ririr
                            djgfjgshdfsh dsucfweuwee ncwecuwegedbwej
                            fugwufgweudgwccwe
                            ewduwefdywegdywe
                            sit amet, consectetur adipisicing yeewv sugewwevjv voluptatem?</p>
                    </div>
                </div>
                <div className="home__project">
                    <img
                        src={ProAgric}
                        alt=''
                    />
                    <div className="home__projectInfo">
                        <h4>School Feeding Program</h4>
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing yeewv sugewwevjv voluptatem?</p>
                    </div>
                </div>
            </div>
            <div>
                
            </div>
            <Footer />
        </div>
    )
}

export default Home
